<template>
  <v-row>
    <v-col cols="12" sm="4">
      <v-text-field
        :value="minutes"
        @change="$emit('update:minutes', $event)"
        type="number"
        label="Minutes"
        name="minutes"
        @keydown.native.enter.prevent
        reverse
      />
    </v-col>
    <v-col cols="12" sm="4">
      <v-text-field
        :value="seconds"
        @change="$emit('update:seconds', $event)"
        type="number"
        label="Seconds"
        name="seconds"
        @keydown.native.enter.prevent
        reverse
      />
    </v-col>
    <v-col cols="12" sm="4">
      <v-text-field
        :value="forcedVolume"
        @change="$emit('update:forcedVolume', $event)"
        type="number"
        label="Volume (oz.)"
        name="volume"
        @keydown.native.enter.prevent
        reverse
      />
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    minutes: {
      type: [String, Number],
      default: 0,
    },
    seconds: {
      type: [String, Number],
      default: 0,
    },
    forcedVolume: {
      type: [String, Number],
      default: 0,
    },
  },
};
</script>
